// Inlined directly from the design-system file (vendored to src/theme/brand/
// by sync-design-system.mjs). The logo is a single theme-adaptive SVG —
// its letterforms use fill="currentColor" and the accent dot reads
// var(--mark-accent) — so it must live in the DOM (not an <img>) to pick up
// the surrounding text color and CSS vars. See .brand-logo in ui.css, which
// sets the color + --mark-accent per theme. Per brand guidelines this is the
// wordmark logo on its own — never the mark and wordmark locked up together.
import logoSvg from "./brand/logo.svg?raw";

// The inlined SVG carries its own role="img" + aria-label + <title>, so the
// non-decorative case needs nothing extra here. Pass alt="" where the product
// name is already rendered alongside (sign-in / pending) to mark it decorative.
export function BrandLogo({ alt }: { alt?: string }) {
  const decorative = alt === "";
  return (
    <span
      className="brand-logo"
      aria-hidden={decorative ? true : undefined}
      dangerouslySetInnerHTML={{ __html: logoSvg }}
    />
  );
}
